'use client';

import ProductAndCategory from '@/joystagram-components/components/consumer/product-and-category';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

export default function ProductAndCategoryClient({
  productOptionsPromise,
  productHeroImagePromise,
  productCylindoHeroImagePromise,
  productBasicDetailsPromise,
  category,
  slug,
  serverCategoryData,
  serverWarehouseId,
}) {
  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <ProductAndCategory
        productOptionsPromise={productOptionsPromise}
        productHeroImagePromise={productHeroImagePromise}
        productCylindoHeroImagePromise={productCylindoHeroImagePromise}
        productBasicDetailsPromise={productBasicDetailsPromise}
        category={category}
        slug={slug}
        serverCategoryData={serverCategoryData}
      />
    </WarehouseIdHydrator>
  );
}
